import { APIGet, APIPost, APIPut, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { TTaxLines } from "redux/reducers/models/facility";

type TGetTaxLine = {
  id?: number;
  name?: string;
  percentage?: number;
  migrate_tax_line_id?: number;
  accounting_reference_id?: number;
};

type TPostTaxLine = {
  name: string;
  percentage?: number;
  accounting_reference_id?: number;
  default?: boolean;
  tax_exempt?: boolean;
};

export type TPutTaxLine = {
  id: number;
  name: string;
  percentage: number;
  migrate_tax_line_id?: number;
  accounting_reference_id?: number;
  compound?: boolean;
  default?: boolean;
  tax_exempt?: boolean;
};

interface IPutArchiveTaxNumber {
  tax_line_id: number;
}

//Get tax lines
export async function GetTaxLine(params: TGetTaxLine, useGlobalLoader?: boolean, token?: CancelToken) {
  return await APIGet<TTaxLines[]>(APIUrl(AdminType.FacilityAdmin, "/client/tax-line"), params, useGlobalLoader, token);
}

//Post Tax Lines
export async function PostTaxLine(params: TPostTaxLine, useGlobalLoader?: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/client/tax-line"), params, useGlobalLoader);
}

//Edit Tax Lines
export async function PutTaxLine(params: TPutTaxLine, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/client/tax-line"), params, useGlobalLoader);
}

export async function PutArchiveTaxLine(params: IPutArchiveTaxNumber, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/client/tax-line/archive"), params, useGlobalLoader);
}
